// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type User from "le-coffre-resources/dist/Notary";
import type { QueryPayload } from "../../../types";
import type { IGetUsersParams, IPutUsersParams } from "./Users";
import { buildUsersReadOperations, buildUsersWriteOperations } from "./usersFactoryOperations";

interface UsersInstance {
	get(q?: IGetUsersParams): Promise<User[]>;
	getAggregated(): Promise<User[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<User>;
	put(uid: string, body: IPutUsersParams): Promise<User>;
	putMyContactEmail(email: string): Promise<void>;
}

let instance: UsersInstance | null = null;
let baseNotaryInstance: IBaseNotary | null = null;

function createUsers(): UsersInstance {
	if (!baseNotaryInstance) {
		baseNotaryInstance = createBaseNotary();
	}

	const baseNotary = baseNotaryInstance;
	const baseUrl = baseNotary.namespaceUrl.concat("/users");

	return {
		...buildUsersReadOperations(baseNotary, baseUrl),
		...buildUsersWriteOperations(baseNotary, baseUrl),
	};
}

export function getUsersInstance(): UsersInstance {
	if (!instance) {
		instance = createUsers();
	}
	return instance;
}
